// The reference a product answers to in logic and report filters (A{a} / A{a}CS{c}); null for a row
// the numbering excludes, the flat position only for a legacy schema that ships no id at all.
export const productCode = av => {
  if (!Object.hasOwn(av, 'id')) return `A${av.position}`
  return av.id?.toUpperCase() || null
}

// Parent, then its variants in value order.
export const productsInDisplayOrder = (answerVariants = []) =>
  (answerVariants || [])
    .filter(av => null != av)
    .sort((a, b) => (a.displayOrder ?? a.position) - (b.displayOrder ?? b.position))
